import { FunctionComponent } from 'react';
import { SxProps, Theme, Typography, Box } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { formatNumber } from '@/features/dashboard/utils';
import { getCycleSummary } from './utils';

interface CompletedCyclesChartTitleProps {
	numberOfCompletedCycles?: number;
	faults?: number;
	totalCycles?: number;
	percentDifference?: number;
	previousCompletedCycles?: number;
	sx?: SxProps<Theme>;
}
function getPercentColor(percent?: number) {
	if (typeof percent !== 'number') return 'inherit';
	if (percent > 0) return 'success.main';
	if (percent < 0) return 'error.main';
	return 'inherit';
}

const Stat: FunctionComponent<{ label: string; value: number }> = ({ label, value }) => (
	<Box sx={{ display: 'flex', flexDirection: 'column' }}>
		<Typography component="span" variant="h3" sx={{ fontWeight: 700 }}>
			{formatNumber(value)}
		</Typography>
		<Typography component="span" variant="caption" sx={{ color: 'text.secondary' }}>
			{label}
		</Typography>
	</Box>
);

const CompletedCyclesChartTitle: FunctionComponent<CompletedCyclesChartTitleProps> = ({
	numberOfCompletedCycles,
	faults,
	totalCycles,
	percentDifference,
	previousCompletedCycles,
	sx,
}) => (
	<Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 2, ...sx }}>
		{(() => {
			const summary = getCycleSummary(numberOfCompletedCycles, faults, totalCycles);
			return (
				<>
					<Stat label="Total cycles" value={summary.total} />
					<Stat label="Faults" value={summary.faults} />
					<Stat label="Completed" value={summary.completed} />
				</>
			);
		})()}
		{typeof percentDifference === 'number' && (
			<Typography
				component="span"
				variant="h6"
				sx={{
					color: getPercentColor(percentDifference),
					fontWeight: 700,
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
				}}
			>
				{percentDifference > 0 && <TrendingUpIcon fontSize="small" />}
				{percentDifference < 0 && <TrendingDownIcon fontSize="small" />}
				{percentDifference > 0 ? '+' : ''}
				{formatNumber(percentDifference)}%
			</Typography>
		)}
		{typeof previousCompletedCycles === 'number' && (
			<Typography component="span" variant="h6" sx={{ color: 'text.secondary', ml: 1 }}>
				{formatNumber(previousCompletedCycles)} CYCLES IN PREVIOUS PERIOD
			</Typography>
		)}
	</Box>
);

export default CompletedCyclesChartTitle;
